import { render, staticRenderFns } from "./RaUserProfileUpload.vue?vue&type=template&id=b2355e3c&scoped=true&"
import script from "./RaUserProfileUpload.vue?vue&type=script&lang=js&"
export * from "./RaUserProfileUpload.vue?vue&type=script&lang=js&"
import style0 from "./RaUserProfileUpload.vue?vue&type=style&index=0&id=b2355e3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2355e3c",
  null
  
)

export default component.exports